var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { getLoggedInRepDetails, getLoggedInRepDetailsFromSession, getShippingRatesService } from "../../../services/apiServices/salesRepDataService";
import store from "../../../reduxStore/store";
import { createB2BOrder, updateB2BOrder, GetCompanyLocationPricelist } from "../../../reduxStore/actions/salesRepDataAction";
import { useTranslation } from "react-i18next";
import { SalesRepDataActionType } from "../../../reduxStore/actions/actionTypes";
import { APPLY_SHIPPING_COST_NO, CREATE_CHECKOUT, DRAFT_ORDER, EDIT_ORDER_FLAG, SHOP_CHECKOUT_SKIP_SHOP_PAY_DOMAIN } from "../../Constant";
import { useDeviceQueries } from "../../../shared/Utilites";
import { SharedFunctions } from "../../SharedFunctions";
export function CreateOrderSharedFunctionsBL(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var _z = useState(""), orderNotes = _z[0], setOrderNotes = _z[1];
    var _0 = useState(""), orderPONumber = _0[0], setOrderPONumber = _0[1];
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    var _1 = useState(), selectedPaymentTerm = _1[0], setSelectedPaymentTerm = _1[1];
    // For now we are not using this code but don't remove it, in future will require.
    // const [taxExemptionDetails, setTaxExemptionDetails] = useState<[]>([]);
    var _2 = useState(false), taxExemptDeatils = _2[0], setTaxExemptDeatils = _2[1];
    var _3 = useState(), defaultDate = _3[0], setDefaultDate = _3[1];
    var _4 = useState([]), shippingCostData = _4[0], setShippingCostData = _4[1];
    var _5 = useState("No"), applyShippingCost = _5[0], setApplyShippingCost = _5[1];
    var _6 = useState(false), shippingCostRadioBtnDisable = _6[0], setShippingCostRadioBtnDisable = _6[1];
    var _7 = useState(""), shippingCost = _7[0], setShippingCost = _7[1];
    var _8 = useState({ msg: "", color: "blue" }), orderPlacedMsg = _8[0], setOrderPlacedMsg = _8[1];
    var _9 = useState({ msg: "", open: false }), alertErrorMsg = _9[0], setAlertErrorMsg = _9[1];
    var currentDate = new Date();
    var todayDateString = currentDate.getFullYear() + "-" + (currentDate.getMonth() + 1).toString().padStart(2, "0") + "-" + currentDate.getDate().toString().padStart(2, "0");
    var selectedCompanyLocationId = useSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.salesRepData) === null || _a === void 0 ? void 0 : _a.customerDetailsCreateInvoice) === null || _b === void 0 ? void 0 : _b.locationId; });
    var durationTypesOfPayment = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.PaymentTermsTemplates;
    var _10 = useSelector(function () { var _a, _b; return (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.productTableData) !== null && _b !== void 0 ? _b : {}; }), selectedProductData = _10.selectedProductData, isQuantityError = _10.isQuantityError, isDiscountError = _10.isDiscountError, discountKeyValueObject = _10.discountKeyValueObject, selectedDiscountType = _10.selectedDiscountType;
    //need to update
    var selectFeature = ((_c = salesRepData.baseData) === null || _c === void 0 ? void 0 : _c.select) ? (_d = salesRepData.baseData) === null || _d === void 0 ? void 0 : _d.select : {};
    var isB2BDraftOrder = ((_e = selectFeature === null || selectFeature === void 0 ? void 0 : selectFeature.featuresAdditionalSettings) === null || _e === void 0 ? void 0 : _e.B2BDraftOrder) ? (_f = selectFeature === null || selectFeature === void 0 ? void 0 : selectFeature.featuresAdditionalSettings) === null || _f === void 0 ? void 0 : _f.B2BDraftOrder : false;
    var isB2BCheckOut = ((_g = selectFeature === null || selectFeature === void 0 ? void 0 : selectFeature.featuresAdditionalSettings) === null || _g === void 0 ? void 0 : _g.B2BCheckOut) ? (_h = selectFeature === null || selectFeature === void 0 ? void 0 : selectFeature.featuresAdditionalSettings) === null || _h === void 0 ? void 0 : _h.B2BCheckOut : false;
    var _11 = useState(""), selectedOrderType = _11[0], setSelectedOrderType = _11[1];
    var _12 = useState(true), sendInvoiceFeature = _12[0], setSendInvoiceFeature = _12[1];
    // Handler for sendInvoice checkbox change with real-time console log
    var handleSendInvoiceChange = function (event) {
        var newValue = event.target.checked;
        setSendInvoiceFeature(newValue);
    };
    var getZoneCode = SharedFunctions().getZoneCode;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var editOrderReduxData = useSelector(function (state) { var _a, _b; return (_b = (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) !== null && _b !== void 0 ? _b : {}; });
    var customerDetailsCreateInvoice = useSelector(function (state) { var _a; return (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.customerDetailsCreateInvoice; });
    var hasFetchedPricelistRef = useRef({});
    // Point 3: Clear B2B-specific fields (notes, PO number, payment terms) when switching away from B2B tab
    useEffect(function () {
        // If customerDetailsCreateInvoice is cleared (empty), it means we switched tabs - clear B2B fields
        if (!(customerDetailsCreateInvoice === null || customerDetailsCreateInvoice === void 0 ? void 0 : customerDetailsCreateInvoice.companyId)) {
            setOrderNotes("");
            setOrderPONumber("");
            setSelectedPaymentTerm(null);
            setTaxExemptDeatils(false);
            setDefaultDate(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerDetailsCreateInvoice === null || customerDetailsCreateInvoice === void 0 ? void 0 : customerDetailsCreateInvoice.companyId]);
    //CheckoutConfirmation popup
    var checkResponsePopUpValue = (_l = (_k = (_j = salesRepData.baseData) === null || _j === void 0 ? void 0 : _j.ConfirmationPopUpStatus) === null || _k === void 0 ? void 0 : _k.isCheckOutPopUpVisible) !== null && _l !== void 0 ? _l : false;
    var _13 = useState((_p = (_o = (_m = salesRepData.baseData) === null || _m === void 0 ? void 0 : _m.ConfirmationPopUpStatus) === null || _o === void 0 ? void 0 : _o.isCheckOutPopUpVisible) !== null && _p !== void 0 ? _p : false), defaultPopupStateFromDb = _13[0], setDefaultPopupStateFromDb = _13[1];
    var isPopUpChecked = ((_q = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.checkoutConfirmationPopUp) === null || _q === void 0 ? void 0 : _q.IscheckBoxChecked) ? (_r = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.checkoutConfirmationPopUp) === null || _r === void 0 ? void 0 : _r.IscheckBoxChecked : false;
    var _14 = useState(false), isConfirmOpen = _14[0], setIsConfirmOpen = _14[1];
    // Discount apply on checkout & automatic discount on checkout
    var _15 = useState(false), discountApplyOnCheckout = _15[0], setDiscountApplyOnCheckout = _15[1];
    var _16 = useState(false), automaticDiscountOnCheckout = _16[0], setAutomaticDiscountOnCheckout = _16[1];
    // order options
    var orderOptions = [
        {
            value: DRAFT_ORDER,
            label: t("customerInvoice_DraftOrderBtn"),
            description: t("customerInvoice_DraftOrderDescription"),
            hide: !isB2BDraftOrder,
        },
        {
            value: CREATE_CHECKOUT,
            label: t("customerInvoice_Checkout"),
            description: t("customerInvoice_CheckoutDescription"),
            hide: !isB2BCheckOut,
        },
    ];
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        try {
            var locationPricelistData = (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.locationPricelistData) !== null && _a !== void 0 ? _a : {};
            var isEditOrder = (editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.actionEvent) === EDIT_ORDER_FLAG;
            var draftOrderObj = (_b = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) !== null && _b !== void 0 ? _b : {};
            // Get location ID - use selectedCompanyLocationId or fallback to editOrderLocationId in edit mode
            var editOrderLocationId = isEditOrder ? (_c = draftOrderObj === null || draftOrderObj === void 0 ? void 0 : draftOrderObj.b2bCompany) === null || _c === void 0 ? void 0 : _c.location_id : null;
            var effectiveLocationId = selectedCompanyLocationId || editOrderLocationId;
            // Fetch locationPricelistData if not available or pricelist is empty (especially in edit mode)
            // Use ref to prevent multiple calls for the same location
            if (effectiveLocationId) {
                var locationData = locationPricelistData === null || locationPricelistData === void 0 ? void 0 : locationPricelistData[effectiveLocationId];
                var hasPricelist = (locationData === null || locationData === void 0 ? void 0 : locationData.priceList) && ((_d = Object.keys(locationData.priceList)) === null || _d === void 0 ? void 0 : _d.length) > 0;
                var alreadyFetched = hasFetchedPricelistRef.current[effectiveLocationId];
                // Only fetch if:
                // 1. We haven't fetched for this location yet, AND
                // 2. Location data doesn't exist OR pricelist is empty
                if (!alreadyFetched && (!locationData || !hasPricelist)) {
                    console.log("Fetching locationPricelistData for location:", effectiveLocationId);
                    hasFetchedPricelistRef.current[effectiveLocationId] = true;
                    dispatch(GetCompanyLocationPricelist(effectiveLocationId, "", false, false));
                }
                else if (hasPricelist) {
                    // Mark as fetched if pricelist is already loaded
                    hasFetchedPricelistRef.current[effectiveLocationId] = true;
                }
            }
            // In edit mode, populate fields from draft order first
            if (isEditOrder && draftOrderObj) {
                // Order Notes
                if (draftOrderObj.note) {
                    setOrderNotes(draftOrderObj.note);
                }
                // PO Number - check both poNumber field and note_attributes
                var poNumber = draftOrderObj.poNumber ||
                    ((_f = (_e = draftOrderObj.note_attributes) === null || _e === void 0 ? void 0 : _e.find(function (attr) { return attr.name === "PO_Number"; })) === null || _f === void 0 ? void 0 : _f.value) ||
                    ((_h = (_g = draftOrderObj.note_attributesList) === null || _g === void 0 ? void 0 : _g.find(function (attr) { return attr.name === "PO_Number"; })) === null || _h === void 0 ? void 0 : _h.value) ||
                    "";
                if (poNumber) {
                    setOrderPONumber(poNumber);
                }
                // Tax Exemption - prioritize customer tax_exempt, fallback to location
                if (((_j = draftOrderObj.customer) === null || _j === void 0 ? void 0 : _j.tax_exempt) !== undefined) {
                    setTaxExemptDeatils(draftOrderObj.customer.tax_exempt);
                }
                // "Apply all eligible automatic discounts" checkbox — restore previously saved value on re-edit.
                setAutomaticDiscountOnCheckout((_k = draftOrderObj === null || draftOrderObj === void 0 ? void 0 : draftOrderObj.accept_automatic_discounts) !== null && _k !== void 0 ? _k : false);
            }
            // Set payment terms from location (only for new orders, not edit mode)
            if (effectiveLocationId && locationPricelistData && ((_l = Object === null || Object === void 0 ? void 0 : Object.keys(locationPricelistData)) === null || _l === void 0 ? void 0 : _l.length) > 0 && locationPricelistData[effectiveLocationId]) {
                var existingPaymentTermForLocation_1 = (_o = (_m = locationPricelistData[effectiveLocationId]) === null || _m === void 0 ? void 0 : _m.paymentTermsTemplateName) !== null && _o !== void 0 ? _o : "";
                if (existingPaymentTermForLocation_1 && durationTypesOfPayment != null && ((_p = Object.keys(durationTypesOfPayment)) === null || _p === void 0 ? void 0 : _p.length) > 0) {
                    var filteredPaymentTerms = getFilteredPaymentTerms(locationPricelistData[effectiveLocationId], Object.values(durationTypesOfPayment));
                    var foundPaymentTerm = filteredPaymentTerms.find(function (term) {
                        var termName = ((term === null || term === void 0 ? void 0 : term.name) || "").toLowerCase().trim();
                        var locationTermName = existingPaymentTermForLocation_1.toLowerCase().trim();
                        return termName === locationTermName;
                    });
                    if (foundPaymentTerm) {
                        setSelectedPaymentTerm(foundPaymentTerm);
                    }
                }
            }
            // Set tax exemption from location (only if not already set from draft order)
            if (!isEditOrder || ((_q = draftOrderObj.customer) === null || _q === void 0 ? void 0 : _q.tax_exempt) === undefined) {
                var taxExemptDeatils_1 = (_s = (_r = locationPricelistData[effectiveLocationId]) === null || _r === void 0 ? void 0 : _r.taxExempt) !== null && _s !== void 0 ? _s : true;
                setTaxExemptDeatils(taxExemptDeatils_1);
            }
        }
        catch (error) {
            console.error("Error in useEffect for location pricelist and order fields:", error);
        }
    }, [selectedCompanyLocationId, editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.actionEvent, (_t = (_s = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _s === void 0 ? void 0 : _s.b2bCompany) === null || _t === void 0 ? void 0 : _t.location_id, salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.locationPricelistData, dispatch]);
    // Separate useEffect for payment terms to ensure it runs when both paymentTerms and durationTypesOfPayment are available
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        try {
            var isEditOrder = (editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.actionEvent) === EDIT_ORDER_FLAG;
            var draftOrderObj = (_a = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) !== null && _a !== void 0 ? _a : {};
            var locationPricelistData = (_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.locationPricelistData) !== null && _b !== void 0 ? _b : {};
            var editOrderLocationId = isEditOrder ? (_c = draftOrderObj === null || draftOrderObj === void 0 ? void 0 : draftOrderObj.b2bCompany) === null || _c === void 0 ? void 0 : _c.location_id : null;
            var effectiveLocationId = selectedCompanyLocationId || editOrderLocationId;
            // Payment Terms - get from draft order response (only in edit mode)
            if (isEditOrder && draftOrderObj.paymentTerms && draftOrderObj.paymentTerms.id) {
                // Check if durationTypesOfPayment is available
                var currentDurationTypesOfPayment = (_e = (_d = store.getState().salesRepData) === null || _d === void 0 ? void 0 : _d.baseData) === null || _e === void 0 ? void 0 : _e.PaymentTermsTemplates;
                if (currentDurationTypesOfPayment != null && ((_f = Object.keys(currentDurationTypesOfPayment)) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                    var allPaymentTerms = Object.values(currentDurationTypesOfPayment);
                    var paymentTermFromDraft = draftOrderObj.paymentTerms;
                    var paymentTermId_1 = paymentTermFromDraft.id;
                    var paymentTermName_1 = paymentTermFromDraft.name;
                    // Find payment term by ID (exact match)
                    var foundPaymentTerm = allPaymentTerms.find(function (term) { return (term === null || term === void 0 ? void 0 : term.id) === paymentTermId_1; });
                    // If not found, try matching by extracting numeric ID from gid format
                    if (!foundPaymentTerm && paymentTermId_1 && paymentTermId_1.includes("/")) {
                        var numericId_1 = paymentTermId_1.split("/").pop();
                        foundPaymentTerm = allPaymentTerms.find(function (term) {
                            var _a;
                            var termId = (_a = term === null || term === void 0 ? void 0 : term.id) === null || _a === void 0 ? void 0 : _a.toString();
                            return termId === paymentTermId_1 || termId === numericId_1 || (termId === null || termId === void 0 ? void 0 : termId.includes(numericId_1));
                        });
                    }
                    // If still not found, try matching by name
                    if (!foundPaymentTerm && paymentTermName_1) {
                        foundPaymentTerm = allPaymentTerms.find(function (term) {
                            var termName = ((term === null || term === void 0 ? void 0 : term.name) || "").toLowerCase().trim();
                            var draftName = paymentTermName_1.toLowerCase().trim();
                            return termName === draftName;
                        });
                    }
                    if (foundPaymentTerm) {
                        // CRITICAL: Get payment term with exact object reference from filtered list
                        // Material-UI Select uses === (object reference) to match values
                        // We MUST use the exact same object reference that's in the MenuItem values
                        var exactPaymentTerm = getPaymentTermWithExactReference(foundPaymentTerm.id, locationPricelistData, effectiveLocationId, allPaymentTerms);
                        if (exactPaymentTerm) {
                            // Use the exact object from filtered list - this will match MenuItem value
                            setSelectedPaymentTerm(exactPaymentTerm);
                        }
                        else if (effectiveLocationId && (locationPricelistData === null || locationPricelistData === void 0 ? void 0 : locationPricelistData[effectiveLocationId])) {
                            // If not found in filtered list but location data exists, try fallback
                            // This handles edge cases where payment term might not be in filtered list
                            setSelectedPaymentTerm(foundPaymentTerm);
                        }
                        // If no location data yet, wait for it to load (don't set payment term yet)
                    }
                }
            }
        }
        catch (error) {
            console.error("Error in useEffect for payment terms:", error);
        }
    }, [
        (_u = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _u === void 0 ? void 0 : _u.paymentTerms,
        selectedCompanyLocationId,
        editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.actionEvent,
        (_w = (_v = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _v === void 0 ? void 0 : _v.b2bCompany) === null || _w === void 0 ? void 0 : _w.location_id,
        salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.locationPricelistData,
    ]);
    useEffect(function () {
        if (checkResponsePopUpValue && !isPopUpChecked) {
            setDefaultPopupStateFromDb(true);
        }
        else {
            setDefaultPopupStateFromDb(isPopUpChecked);
        }
    }, [isPopUpChecked, checkResponsePopUpValue]);
    var handlePaymentTermsPeriod = function (e) {
        var value = e.target.value;
        setSelectedPaymentTerm(value);
    };
    var handleDateSelection = function (e) {
        if (e.target.value !== "") {
            var date = new Date(e.target.value).toISOString();
            setDefaultDate(date);
        }
        else {
            setDefaultDate("");
        }
    };
    var GetShippingRatesOnSelectedAddress = function () { return __awaiter(_this, void 0, void 0, function () {
        var customerAddress, CustomerAddressData, responseShippingRates, error_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    setShippingCost("");
                    setShippingCostData([]);
                    setApplyShippingCost("");
                    setShippingCostRadioBtnDisable(false);
                    customerAddress = (_c = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.customerDetailsCreateInvoice) === null || _b === void 0 ? void 0 : _b.ShippingAddress) !== null && _c !== void 0 ? _c : {};
                    CustomerAddressData = {
                        customerCountry: (customerAddress === null || customerAddress === void 0 ? void 0 : customerAddress.country) === "Great Britain (UK)"
                            ? "United Kingdom"
                            : (customerAddress === null || customerAddress === void 0 ? void 0 : customerAddress.country) === "United States of America"
                                ? "United States"
                                : (customerAddress === null || customerAddress === void 0 ? void 0 : customerAddress.country) || "",
                        customerProvince: (customerAddress === null || customerAddress === void 0 ? void 0 : customerAddress.province) || (customerAddress === null || customerAddress === void 0 ? void 0 : customerAddress.city) || "",
                        customerZip: (customerAddress === null || customerAddress === void 0 ? void 0 : customerAddress.zip) || "",
                    };
                    setShippingCost(t("customerInvoice_CalculatingShippingRates_Msg"));
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getShippingRatesService(CustomerAddressData)];
                case 2:
                    responseShippingRates = _e.sent();
                    setShippingCost("");
                    if (((_d = responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.shipping_rates) === null || _d === void 0 ? void 0 : _d.length) === 0) {
                        setAlertErrorMsg({ msg: t("ShippingCost_AddressError"), open: true, severity: "warning" });
                        setApplyShippingCost("No");
                        setShippingCostRadioBtnDisable(true);
                        return [2 /*return*/, false];
                    }
                    if ((responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.message) !== "Success") {
                        setAlertErrorMsg({ msg: (responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.message) === "Success" ? t("customerInvoice_ShippingCostErrorMsg_TryAgain") : responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.message, open: true });
                        return [2 /*return*/, false];
                    }
                    setShippingCostData((responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.shipping_rates) || []);
                    return [2 /*return*/, true];
                case 3:
                    error_1 = _e.sent();
                    setShippingCost("");
                    setAlertErrorMsg({ msg: t("customerInvoice_ShippingCostErrorMsg_TryAgain"), open: true });
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleShippingCostApply = function (param) {
        setApplyShippingCost(param);
        if (param === APPLY_SHIPPING_COST_NO) {
            setShippingCost("");
            setShippingCostData([]);
        }
    };
    var formatedAddress = function (address) {
        var _a, _b, _c, _d;
        return {
            firstName: (address === null || address === void 0 ? void 0 : address.firstName) || "",
            lastName: (address === null || address === void 0 ? void 0 : address.lastName) || "",
            address1: (address === null || address === void 0 ? void 0 : address.address1) || "",
            address2: (address === null || address === void 0 ? void 0 : address.address2) || "",
            city: (address === null || address === void 0 ? void 0 : address.city) || "",
            provinceCode: getZoneCode((_a = address === null || address === void 0 ? void 0 : address.countryCode) !== null && _a !== void 0 ? _a : "", (_b = address === null || address === void 0 ? void 0 : address.province) !== null && _b !== void 0 ? _b : ""),
            zip: (address === null || address === void 0 ? void 0 : address.zipNumber) || "",
            phone: (address === null || address === void 0 ? void 0 : address.mobileNumber) || "",
            countryCode: (_d = (_c = address === null || address === void 0 ? void 0 : address.countryCode) === null || _c === void 0 ? void 0 : _c.toUpperCase()) !== null && _d !== void 0 ? _d : "",
        };
    };
    // Send Invoice & Order Create B2B order
    var CreateB2BOrder = function (orderType) { return __awaiter(_this, void 0, void 0, function () {
        var _a, CustomerId, email, salesRepEmail, salesRepId, selectedCompanyDetails, shippingAddress, billingAddress, editOrderReduxData_1, isEditOrder_1, selectShippingCost, shipping_Name, shipping_Cost, updatedDiscountKeyValueObject, key, variantId, selectedProducts, toShopifyGid, companyContactIdForOrder, createOrderDataObject, successDataPost, _b, isValidUrl, successMsg, invoiceRedirectUrl_1, shopName_1, errorMsg, error_2, errorMsg;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    _m.trys.push([0, 6, , 7]);
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, email = _a.email;
                    salesRepEmail = email;
                    salesRepId = CustomerId;
                    selectedCompanyDetails = store.getState().salesRepData.customerDetailsCreateInvoice;
                    shippingAddress = formatedAddress(selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.ShippingAddress);
                    billingAddress = formatedAddress(selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.BillingAddress);
                    editOrderReduxData_1 = (_d = (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.editDraftOrder) !== null && _d !== void 0 ? _d : {};
                    isEditOrder_1 = (editOrderReduxData_1 === null || editOrderReduxData_1 === void 0 ? void 0 : editOrderReduxData_1.actionEvent) === EDIT_ORDER_FLAG;
                    selectShippingCost = shippingCost === null || shippingCost === void 0 ? void 0 : shippingCost.split("/");
                    shipping_Name = selectShippingCost[0] !== "" ? selectShippingCost[0] : null;
                    shipping_Cost = selectShippingCost[1] !== "" ? selectShippingCost[1] : null;
                    if (applyShippingCost === "") {
                        setAlertErrorMsg({ msg: t("customerInvoice_ShippingCostAddOrNot_Msg"), open: true });
                    }
                    updatedDiscountKeyValueObject = {};
                    if (discountKeyValueObject && ((_e = Object.keys(discountKeyValueObject)) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                        for (key in discountKeyValueObject) {
                            if (key !== "discountOnSubTotal") {
                                variantId = key === null || key === void 0 ? void 0 : key.split("gid://shopify/ProductVariant/")[1];
                                updatedDiscountKeyValueObject[variantId] = discountKeyValueObject[key];
                            }
                            else {
                                updatedDiscountKeyValueObject[key] = discountKeyValueObject[key];
                            }
                        }
                    }
                    if (!(applyShippingCost === APPLY_SHIPPING_COST_NO || shippingCost !== "")) return [3 /*break*/, 5];
                    selectedProducts = selectedProductData !== null && selectedProductData !== void 0 ? selectedProductData : [];
                    toShopifyGid = function (id, entity) {
                        var idString = String(id !== null && id !== void 0 ? id : "").trim();
                        if (!idString)
                            return "";
                        if (idString.startsWith("gid://"))
                            return idString;
                        return "gid://shopify/".concat(entity, "/").concat(idString);
                    };
                    companyContactIdForOrder = (selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.locationMainContactId) || (selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.customerId);
                    createOrderDataObject = __assign({
                        prods: JSON.stringify(selectedProducts),
                        shippingAddress: JSON.stringify(shippingAddress),
                        billingAddress: JSON.stringify(billingAddress),
                        email: salesRepEmail,
                        cusemail: selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.customerEmail,
                        customerId: salesRepId,
                        customer_gid: toShopifyGid(companyContactIdForOrder, "CompanyContact"),
                        companyContactId: toShopifyGid(companyContactIdForOrder, "CompanyContact"),
                        companyLocationId: selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.locationId,
                        companyName: selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.companyName,
                        companyLocationName: selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.locationName,
                        companyId: selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.companyId,
                        ponumber: orderPONumber,
                        message: orderNotes,
                        paymentTermsTemplateId: selectedPaymentTerm === null || selectedPaymentTerm === void 0 ? void 0 : selectedPaymentTerm.id,
                        paymentTermType: selectedPaymentTerm === null || selectedPaymentTerm === void 0 ? void 0 : selectedPaymentTerm.dueInDays,
                        dueDateInput: (selectedPaymentTerm === null || selectedPaymentTerm === void 0 ? void 0 : selectedPaymentTerm.paymentTermsType) === "FIXED" ? defaultDate : "",
                        shippingprice: shipping_Cost,
                        shippingtitle: shipping_Name,
                        lineItemDiscountObject: updatedDiscountKeyValueObject,
                        discountApplyOnSubTotal: (updatedDiscountKeyValueObject === null || updatedDiscountKeyValueObject === void 0 ? void 0 : updatedDiscountKeyValueObject.discountOnSubTotal) ? Number(updatedDiscountKeyValueObject === null || updatedDiscountKeyValueObject === void 0 ? void 0 : updatedDiscountKeyValueObject.discountOnSubTotal) : 0,
                        discountType: selectedDiscountType,
                        sendInvoice: sendInvoiceFeature,
                        doNotShowCheckOutInfoPopUp: orderType === CREATE_CHECKOUT ? defaultPopupStateFromDb : false,
                        isApplyDiscountOnCheckout: discountApplyOnCheckout !== null && discountApplyOnCheckout !== void 0 ? discountApplyOnCheckout : false,
                        isAutomaticDiscountOnCheckout: automaticDiscountOnCheckout !== null && automaticDiscountOnCheckout !== void 0 ? automaticDiscountOnCheckout : false,
                    }, (isEditOrder_1 && {
                        orderId: (_f = editOrderReduxData_1 === null || editOrderReduxData_1 === void 0 ? void 0 : editOrderReduxData_1.draftOrderObj) === null || _f === void 0 ? void 0 : _f.id,
                        orderTags: (_g = editOrderReduxData_1 === null || editOrderReduxData_1 === void 0 ? void 0 : editOrderReduxData_1.draftOrderObj) === null || _g === void 0 ? void 0 : _g.tags,
                        additionalNoteDetails: (_j = (_h = editOrderReduxData_1 === null || editOrderReduxData_1 === void 0 ? void 0 : editOrderReduxData_1.draftOrderObj) === null || _h === void 0 ? void 0 : _h.note_attributesList) !== null && _j !== void 0 ? _j : [],
                    }));
                    setOrderPlacedMsg({ msg: t("customerInvoice_Sending_Msg"), color: "blue" });
                    props === null || props === void 0 ? void 0 : props.setOrderCreatedSuccesfullyFlag(false);
                    if (!isEditOrder_1) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateB2BOrder(createOrderDataObject, (_k = editOrderReduxData_1 === null || editOrderReduxData_1 === void 0 ? void 0 : editOrderReduxData_1.draftOrderObj) === null || _k === void 0 ? void 0 : _k.id)];
                case 1:
                    _b = _m.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createB2BOrder(createOrderDataObject)];
                case 3:
                    _b = _m.sent();
                    _m.label = 4;
                case 4:
                    successDataPost = _b;
                    isValidUrl = typeof successDataPost === "string" && (successDataPost === null || successDataPost === void 0 ? void 0 : successDataPost.startsWith("http"));
                    if (isValidUrl) {
                        successMsg = isEditOrder_1 ? t("customerInvoice_OrderUpdatedSuccessfullyMsg") || "Order updated successfully" : t("customerInvoice_OrderCreatedSuccessfullyMsg");
                        setOrderPlacedMsg({ msg: successMsg, color: "green" });
                        setAlertErrorMsg({ msg: successMsg, open: true, severity: "success" });
                        setTimeout(function () {
                            setOrderPlacedMsg({ msg: "", color: "" });
                            saveDataToStore("", SalesRepDataActionType.CUSTOMER_DETAILS_CREATE_INVOICE);
                            // Clear edit order state
                            if (isEditOrder_1) {
                                saveDataToStore({}, SalesRepDataActionType.EDIT_DRAFT_ORDER);
                            }
                        }, 3000);
                        props === null || props === void 0 ? void 0 : props.setOrderCreatedSuccesfullyFlag(true);
                        props === null || props === void 0 ? void 0 : props.EmptyAllFieldsOnSuccess();
                        saveDataToStore({}, SalesRepDataActionType.PRODUCT_TABLE_DATA);
                        saveDataToStore([], SalesRepDataActionType.DRAFT_ORDER_DATA);
                        setSelectedOrderType("");
                        if (orderType === CREATE_CHECKOUT) {
                            setIsConfirmOpen(false);
                            invoiceRedirectUrl_1 = isEditOrder_1 ? ((_l = editOrderReduxData_1 === null || editOrderReduxData_1 === void 0 ? void 0 : editOrderReduxData_1.draftOrderObj) === null || _l === void 0 ? void 0 : _l.invoice_url) || successDataPost : successDataPost;
                            shopName_1 = getLoggedInRepDetails().shopName;
                            setTimeout(function () {
                                if (typeof invoiceRedirectUrl_1 === "string" && invoiceRedirectUrl_1) {
                                    var appendSkipShopPay = shopName_1 === SHOP_CHECKOUT_SKIP_SHOP_PAY_DOMAIN;
                                    window.location.href = appendSkipShopPay ? "".concat(invoiceRedirectUrl_1).concat(invoiceRedirectUrl_1.includes("?") ? "&" : "?", "skip_shop_pay=true") : invoiceRedirectUrl_1;
                                }
                                else {
                                    window.location.href = invoiceRedirectUrl_1;
                                }
                            }, 5000);
                        }
                    }
                    else {
                        errorMsg = typeof successDataPost === "string" ? successDataPost : t("customerInvoice_ErrorMsgTryAgain");
                        setAlertErrorMsg({ msg: errorMsg, open: true, severity: "error" });
                        setOrderPlacedMsg({ msg: errorMsg, color: "red" });
                    }
                    setTimeout(function () {
                        setOrderPlacedMsg({ msg: "", color: "" });
                    }, 2000);
                    setIsConfirmOpen(false);
                    _m.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_2 = _m.sent();
                    errorMsg = t("customerInvoice_ErrorMsgTryAgain");
                    setAlertErrorMsg({ msg: errorMsg, open: true, severity: "error" });
                    setOrderPlacedMsg({ msg: errorMsg, color: "red" });
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    var handleOrderTypeChange = function (value) {
        setSelectedOrderType(value);
    };
    var handleOpenConfirm = function () {
        setIsConfirmOpen(!isConfirmOpen);
    };
    function saveDataToStore(payloadData, actionType) {
        return __awaiter(this, void 0, void 0, function () {
            var action;
            return __generator(this, function (_a) {
                action = {
                    payload: payloadData,
                    type: actionType,
                };
                dispatch(action);
                return [2 /*return*/];
            });
        });
    }
    var b2borderCreateBtnDisabled = selectedOrderType != "" &&
        selectedProductData &&
        (selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.length) > 0 &&
        salesRepData.customerDetailsCreateInvoice &&
        ((_x = Object.keys(salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.customerDetailsCreateInvoice)) === null || _x === void 0 ? void 0 : _x.length) !== 0 &&
        isQuantityError &&
        Object.values(isQuantityError).every(function (value) { return value === false; }) &&
        isDiscountError &&
        ((_y = Object.values(isDiscountError)) === null || _y === void 0 ? void 0 : _y.every(function (value) { return value === false; }));
    var B2BCreateOrderButtonDisable = (selectedPaymentTerm === null || selectedPaymentTerm === void 0 ? void 0 : selectedPaymentTerm.paymentTermsType) === "FIXED" && !defaultDate;
    var getFilteredPaymentTerms = function (selectedLocationPaymentTerms, allTemplates) {
        var _a;
        try {
            var name_1 = (_a = selectedLocationPaymentTerms === null || selectedLocationPaymentTerms === void 0 ? void 0 : selectedLocationPaymentTerms.PaymentTermsName) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            var matched = allTemplates.find(function (term) { var _a; return ((_a = term.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === name_1; });
            return matched ? [matched] : allTemplates;
        }
        catch (error) {
            console.error("Error in getFilteredPaymentTerms:", error);
            return allTemplates; // fallback to returning all templates
        }
    };
    // Helper function to get payment term with exact object reference from filtered list
    // This ensures the object reference matches what's used in MenuItem values
    var getPaymentTermWithExactReference = function (paymentTermId, locationPricelistData, effectiveLocationId, allPaymentTerms) {
        if (effectiveLocationId && (locationPricelistData === null || locationPricelistData === void 0 ? void 0 : locationPricelistData[effectiveLocationId])) {
            var filteredPaymentTerms = getFilteredPaymentTerms(locationPricelistData[effectiveLocationId], allPaymentTerms);
            // Find the exact object reference from filtered list
            var matchingTerm = filteredPaymentTerms.find(function (term) { return (term === null || term === void 0 ? void 0 : term.id) === paymentTermId; });
            return matchingTerm || null;
        }
        return null;
    };
    return {
        handlePaymentTermsPeriod: handlePaymentTermsPeriod,
        durationTypesOfPayment: durationTypesOfPayment,
        handleDateSelection: handleDateSelection,
        selectedPaymentTerm: selectedPaymentTerm,
        orderNotes: orderNotes,
        orderPONumber: orderPONumber,
        todayDateString: todayDateString,
        setOrderNotes: setOrderNotes,
        setOrderPONumber: setOrderPONumber,
        taxExemptDeatils: taxExemptDeatils,
        CreateB2BOrder: CreateB2BOrder,
        alertErrorMsg: alertErrorMsg,
        handleAlertMsgClose: handleAlertMsgClose,
        orderPlacedMsg: orderPlacedMsg,
        b2borderCreateBtnDisabled: b2borderCreateBtnDisabled,
        B2BCreateOrderButtonDisable: B2BCreateOrderButtonDisable,
        selectedOrderType: selectedOrderType,
        orderOptions: orderOptions,
        sendInvoiceFeature: sendInvoiceFeature,
        setSendInvoiceFeature: setSendInvoiceFeature,
        handleSendInvoiceChange: handleSendInvoiceChange,
        selectedCompanyLocationId: selectedCompanyLocationId,
        handleOrderTypeChange: handleOrderTypeChange,
        handleOpenConfirm: handleOpenConfirm,
        defaultPopupStateFromDb: defaultPopupStateFromDb,
        isConfirmOpen: isConfirmOpen,
        getFilteredPaymentTerms: getFilteredPaymentTerms,
        discountApplyOnCheckout: discountApplyOnCheckout,
        automaticDiscountOnCheckout: automaticDiscountOnCheckout,
        setDiscountApplyOnCheckout: setDiscountApplyOnCheckout,
        setAutomaticDiscountOnCheckout: setAutomaticDiscountOnCheckout,
    };
}
export function CssConstantObjects() {
    var isMobile = useDeviceQueries();
    var selectPaymentTermCss = {
        minWidth: 200,
        backgroundColor: "white",
    };
    var ST_CI_MinWidth = {
        minWidth: 228,
        mt: 1,
    };
    var ST_CI_ShippingCost = {
        display: "flex",
        flexWrap: "wrap",
    };
    var ST_CI_BtnArea = {
        display: "flex",
        justifyContent: isMobile ? "start" : "flex-end",
        mb: 2,
    };
    var ST_CI_Heading_Font = {
        fontWeight: "bold",
        fontFamily: "'Inter', sans-serif",
        fontSize: "1.3rem",
        whiteSpace: "nowrap",
    };
    var ST_CI_DisplayFlexEnd = {
        display: "flex",
        justifyContent: isMobile ? "start" : "flex-end",
        marginTop: isMobile ? 2 : 0,
    };
    var ST_CI_SendInvoice_CreateOrder_Btn = {
        width: isMobile ? "100%" : 100,
        height: isMobile ? 45 : 38,
        fontSize: isMobile ? 14 : 12,
        backgroundColor: "#1f76ce",
    };
    return {
        ST_CI_MinWidth: ST_CI_MinWidth,
        selectPaymentTermCss: selectPaymentTermCss,
        ST_CI_ShippingCost: ST_CI_ShippingCost,
        ST_CI_SendInvoice_CreateOrder_Btn: ST_CI_SendInvoice_CreateOrder_Btn,
        ST_CI_BtnArea: ST_CI_BtnArea,
        ST_CI_Heading_Font: ST_CI_Heading_Font,
        ST_CI_DisplayFlexEnd: ST_CI_DisplayFlexEnd,
    };
}
